import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const KEY = 'feedbackLastPage';

// Records the last page the user was on before opening More, so Feedback can
// say where the problem happened rather than always reporting "/more".
export const LastPageTracker = () => {
    const { pathname, search } = useLocation();
    useEffect(() => {
        if (!pathname.startsWith('/more')) {
            sessionStorage.setItem(KEY, pathname + search);
        }
    }, [pathname, search]);
    return null;
};

export const getLastPage = () => sessionStorage.getItem(KEY) || '(unknown)';
